// extracted by mini-css-extract-plugin
export default {"overlay":"kz-z","bodyOpen":"lz-z","content":"mz-z","header":"nz-z","close":"oz-z","closeNoHeading":"pz-z"};